var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.33,
    height: 14.664,
    viewBox: "0 0 18.33 14.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-truck",
    "data-name": "Icon awesome-truck",
    d: "M17.872,10.082h-.458v-3.1a1.375,1.375,0,0,0-.4-.971L14.149,3.153a1.375,1.375,0,0,0-.971-.4H11.915V1.375A1.375,1.375,0,0,0,10.54,0H1.375A1.375,1.375,0,0,0,0,1.375V10.54a1.375,1.375,0,0,0,1.375,1.375h.458a2.75,2.75,0,0,0,5.5,0H11a2.75,2.75,0,0,0,5.5,0h1.375a.46.46,0,0,0,.458-.458V10.54A.46.46,0,0,0,17.872,10.082ZM4.583,13.289a1.375,1.375,0,1,1,1.375-1.375A1.375,1.375,0,0,1,4.583,13.289Zm9.165,0a1.375,1.375,0,1,1,1.375-1.375A1.375,1.375,0,0,1,13.748,13.289Zm2.291-5.957H11.915V4.124h1.263l2.861,2.861Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenIcon);
export default __webpack_public_path__ + "static/media/VenIcon.b32a1a22f7a9c6d233366a9b655862a1.svg";
export { ForwardRef as ReactComponent };